const APP_VERSION_META_PATTERN = /<meta[^>]+name=["']app-version["'][^>]+content=["']([^"']+)["']/i;

export const readAppVersion = (html: string): string | null => html.match(APP_VERSION_META_PATTERN)?.[1] ?? null;

interface PrecacheWrite {
	request: Request;
	response: Response;
}

// Replaces Workbox's default precache check (status < 400), so it repeats it before checking the build.
const precacheOwnBuild = (buildVersion: string | undefined) => ({
	cacheWillUpdate: async ({ request, response }: PrecacheWrite): Promise<Response | null> => {
		if (response.status >= 400) return null;
		const isPage = new URL(request.url).pathname.endsWith(".html");
		// Mid-rollout an older pod answers a file it doesn't have with index.html.
		if (!isPage) return response.headers.get("content-type")?.includes("text/html") ? null : response;
		if (!buildVersion) return response;
		const servedVersion = readAppVersion(await response.clone().text());
		return servedVersion === null || servedVersion === buildVersion ? response : null;
	}
});

export default precacheOwnBuild;
